import axios from 'axios';
// const baseDomain = 'https://print-api.itechdoor.cloud/api';
const baseDomain = 'https://januspg.net/api';
export const baseUrl = `${baseDomain}`;
import { service } from '@/services/singleton.service';
export function HttpService(baseURL) {
  const token = localStorage.getItem('token') 

  const config = {
    baseURL: baseURL,
    headers: {
      Authorization: ''
    }
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  const instance = axios.create(config)

  instance.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      const status = error.response?.status || error.request?.status

      if (status === 401) {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        service.auth.logout()
      }

      if ([422, 500].includes(status)) {
        service.notification.showError(
          error.response?.data?.message || error.message
        )
      }

      return Promise.reject(error)
    }
  )

  return instance
}
export function getToken() {
  const localToken = localStorage.getItem('token');
  const sessionToken = sessionStorage.getItem('token');
  return localToken || sessionToken || null;
}

// ✅ Set token and apply to axios default headers
export function setToken(token) {
  localStorage.setItem('token', token);
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  axiosInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
  axiosInstance.defaults.withCredentials = true;
}

// ✅ Axios instance
const axiosInstance = axios.create({
  baseURL: baseUrl,
});

// ✅ Automatically apply token on every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Export default instance
export default axiosInstance;

// ✅ Utility for query params
export const serializeQuery = query => {
  return Object.keys(query)
    .map(
      key =>
        `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`
    )
    .join('&');
};
